export default __webpack_public_path__ + "static/media/smart_speaker2.131c75f5.jpg";